/* ============================================================
   KICK SPEED: COLLECTION FILTERS
   File: assets/ks-filters.js (markup: snippets/ks-filters.liquid)

   Every change asks Shopify for the same collection section with the
   new filters (Section Rendering API, ?section_id=...) and swaps only the
   parts marked data-ksf="...": the cards, the counts, the chips, the
   filter form and the products. No page reload, the address bar follows,
   Back and Forward work.

   Computers, "bar" layout (.ks-f--bar): each filter is a button in a row
   above the products and opens a small window under it (the filter's
   <details>). One window at a time; a click outside, Esc or scrolling the
   bar away closes it. It stays open while the products change, so several
   sizes can be picked in a row. Switches (Toe stops, In stock) sit right
   in the bar. The row stays one row: filters that do not fit go behind
   More filters. That button, and further down the page the Filter button
   in the bar under the header, open all filters as a panel from the left.

   Phones and tablets: the filters open as a sheet from the bottom. It
   counts live ("Show 12 products"), closes with the X, the button, Esc,
   the phone's Back gesture or a pull down, and keeps focus inside while
   open. While it is
   open the page carries js-drawer-open, the theme's own "a drawer is open"
   class: it stops the page scrolling and hides the Kick Dock, the chat
   bubble and the currency button, like every other drawer.
   ============================================================ */
(function () {
  'use strict';

  var BP_DESK = '(min-width: 990px)';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__ksf) return;
    root.__ksf = true;

    var html = document.documentElement;
    var sid = root.getAttribute('data-section');
    var mqDesk = window.matchMedia(BP_DESK);
    var ctrl = null, timer = 0, sheetOpen = false, closing = false, opener = null;
    var sheetFrom = null, wantResults = false; /* the filters when the panel opened */
    var lastUrl = clean(location.href);
    var userOpen = {}; /* group key -> open/closed by the shopper (panel) */
    var popKey = null; /* the filter whose small window is open (bar) */
    var floatEl = root.querySelector('[data-ksf-float]');
    var barEl = root.querySelector('.ks-f__bar');

    function q(sel, ctx) { return (ctx || root).querySelector(sel); }
    function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
    function form() { return q('[data-ksf-form]'); }
    function panel() { return q('[data-ksf-panel]'); }
    /* the row of filter buttons is showing (computers, "bar" layout, the
       panel from the left closed) */
    function barMode() { return root.classList.contains('ks-f--bar') && mqDesk.matches && !sheetOpen; }
    function esc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&'); }

    /* the address without section_id / page leftovers */
    function clean(url) {
      var u = new URL(url, location.href);
      u.searchParams.delete('section_id');
      return u.pathname + (u.search ? u.search : '');
    }

    function paramsFromForm() {
      var p = new URLSearchParams();
      var f = form();
      if (!f) return p;
      var sel = q('[data-ksf-sort]');
      var defSort = sel ? sel.getAttribute('data-default') : null;
      new FormData(f).forEach(function (v, k) {
        if (v === '' || v == null) return;
        if (k === 'sort_by' && v === defSort) return; /* the usual order: keep the address short */
        p.append(k, v);
      });
      return p;
    }
    function urlFromForm() {
      var s = paramsFromForm().toString();
      return location.pathname + (s ? '?' + s : '');
    }
    function apply(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () { go(urlFromForm(), 'push'); }, delay || 0);
    }

    /* ---------- fetch and swap ---------- */
    function go(url, mode) {
      url = clean(url);
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', sid);
      return fetch(u.toString(), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-ks-f]');
          if (!fresh) throw new Error('no filters in response');
          swap(fresh);
          lastUrl = url;
          if (mode === 'push') {
            if (sheetOpen) history.replaceState({ ksf: 1, sheet: 1 }, '', url);
            else history.pushState({ ksf: 1 }, '', url);
          }
          root.classList.remove('is-loading');
          root.removeAttribute('aria-busy');
          after(mode);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          /* anything unexpected: a normal page load gives the same result */
          location.href = url;
        });
    }

    function keyOf(el) {
      if (!el || !root.contains(el)) return null;
      if (el.name && el.form && el.type === 'checkbox') return { sel: 'input[name="' + esc(el.name) + '"][value="' + esc(el.value) + '"]' };
      if (el.hasAttribute && el.hasAttribute('data-ksf-toggle')) return { sel: '[data-ksf-toggle][data-name="' + esc(el.getAttribute('data-name')) + '"][data-value="' + esc(el.getAttribute('data-value')) + '"]' };
      if (el.hasAttribute && el.hasAttribute('data-ksf-lo')) return { sel: '[data-ksf-lo]' };
      if (el.hasAttribute && el.hasAttribute('data-ksf-hi')) return { sel: '[data-ksf-hi]' };
      return null;
    }

    function swap(fresh) {
      var focusKey = keyOf(document.activeElement);
      var f = form();
      var formScroll = f ? f.scrollTop : 0;

      qa('[data-ksf]').forEach(function (el) {
        var key = el.getAttribute('data-ksf');
        var nu = fresh.querySelector('[data-ksf="' + key + '"]');
        el.innerHTML = nu ? nu.innerHTML : '';
      });
      root.setAttribute('data-count', fresh.getAttribute('data-count') || '');
      root.setAttribute('data-active', fresh.getAttribute('data-active') || '0');
      root.classList.toggle('ks-f--cards', fresh.classList.contains('ks-f--cards'));

      /* groups the shopper opened or closed stay that way; in the bar,
         the small window that was open stays open */
      paintFoot();
      layout();
      f = form();
      if (f) f.scrollTop = formScroll;
      if (focusKey) {
        var back = q(focusKey.sel);
        if (back) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
      }
    }

    function after(mode) {
      try { if (window.theme && typeof theme.reinitProductGridItem === 'function') theme.reinitProductGridItem(); } catch (e) {}
      refreshMoney();
      initPrice();
      try { document.dispatchEvent(new CustomEvent('collection:reloaded')); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('ks:filters', { detail: { url: lastUrl } })); } catch (e) {}
      track('ks_filter_apply');
      if (!sheetOpen && mode !== 'pop') toResults(false);
    }

    var moneyT = 0;
    function refreshMoney() {
      clearTimeout(moneyT);
      moneyT = setTimeout(function () {
        var bc = window.baCurr;
        if (bc && typeof bc.refreshConversion === 'function') { try { bc.refreshConversion(); } catch (e) {} }
      }, 30);
    }

    function track(name) {
      var K = window.KSFinder;
      if (!K || typeof K.track !== 'function') return;
      var keys = [];
      paramsFromForm().forEach(function (v, k) {
        if (k.indexOf('filter.') !== 0) return;
        var short = k.replace(/^filter\.(p\.m\.|v\.option\.|p\.|v\.)/, '').replace(/\.(gte|lte)$/, '');
        if (keys.indexOf(short) < 0) keys.push(short);
      });
      K.track(name, {
        filters: keys.join(',').slice(0, 100),
        filter_count: +(root.getAttribute('data-active') || 0),
        results: +(root.getAttribute('data-count') || 0)
      });
    }

    /* ---------- groups: accordion in the panel, small windows in the bar ---------- */
    function groups() { return qa('[data-ksf-group]'); }
    function keyOfGroup(d) { return d.getAttribute('data-ksf-group'); }
    function popGroup() {
      if (!popKey) return null;
      var d = q('[data-ksf-group="' + esc(popKey) + '"]');
      return d && !d.hasAttribute('data-ksf-inline') ? d : null;
    }
    /* a window that would run past the right edge opens to the left */
    function place(d) {
      d.classList.remove('is-end');
      var pop = q('.ks-f__pop', d);
      if (!pop) return;
      var r = pop.getBoundingClientRect();
      var max = (document.documentElement.clientWidth || window.innerWidth) - 12;
      if (r.right > max) d.classList.add('is-end');
    }
    function layout() {
      var bar = barMode();
      groups().forEach(function (d) {
        var k = keyOfGroup(d);
        var s = q('.ks-f__summary', d);
        if (bar) {
          var on = d.hasAttribute('data-ksf-inline') || k === popKey;
          if (d.open !== on) d.open = on;
          if (s) {
            if (d.hasAttribute('data-ksf-inline')) { s.setAttribute('tabindex', '-1'); s.setAttribute('aria-hidden', 'true'); }
            else { s.removeAttribute('tabindex'); s.removeAttribute('aria-hidden'); }
          }
        } else {
          var want = Object.prototype.hasOwnProperty.call(userOpen, k) ? userOpen[k] : true;
          if (d.open !== want) d.open = want;
          if (s) { s.removeAttribute('tabindex'); s.removeAttribute('aria-hidden'); }
          d.classList.remove('is-end');
        }
      });
      fitBar(bar);
      if (bar) {
        var g = popGroup();
        if (!g) popKey = null; else place(g);
      }
      root.classList.add('is-ready');
    }
    /* computers, "bar": the row of filters stays one row. Filters that do
       not fit go behind More filters, which opens all filters in the panel;
       its badge counts what is switched on among them. */
    function fitBar(bar) {
      var more = q('[data-ksf-more]');
      if (!more) return;
      var gs = groups();
      gs.forEach(function (g) { g.classList.remove('is-over'); });
      more.hidden = true;
      more.classList.remove('is-set');
      if (!bar) return;
      var vis = gs.filter(function (g) { return g.getClientRects().length > 0; });
      if (vis.length < 2) return;
      var top0 = vis[0].getBoundingClientRect().top;
      var row1 = function (el) { return el.getBoundingClientRect().top < top0 + 4; };
      if (vis.every(row1)) return;
      more.hidden = false;
      var i = vis.length - 1;
      while (i > 0 && !(row1(more) && vis.slice(0, i + 1).every(row1))) {
        vis[i].classList.add('is-over');
        i--;
      }
      var n = 0;
      vis.forEach(function (g) {
        if (!g.classList.contains('is-over')) return;
        if (keyOfGroup(g) === popKey) { popKey = null; g.open = false; }
        n += g.classList.contains('ks-f__group--price')
          ? (g.classList.contains('is-set') ? 1 : 0)
          : g.querySelectorAll('input[type="checkbox"]:checked').length;
      });
      var badge = q('[data-ksf-more-n]', more);
      if (badge) badge.textContent = n ? String(n) : '';
      more.classList.toggle('is-set', n > 0);
    }
    function openPop(d) {
      popKey = keyOfGroup(d);
      paintFoot();
      layout();
    }
    function closePop(focusBack) {
      var g = popGroup();
      popKey = null;
      layout();
      if (focusBack && g) {
        var s = q('.ks-f__summary', g);
        if (s) { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }
      }
    }
    /* one filter cleared from its window */
    function clearGroup(d) {
      qa('input[type="checkbox"]', d).forEach(function (i) {
        i.checked = false;
        var lab = i.closest('label');
        if (lab) lab.classList.remove('is-on');
      });
      qa('[data-ksf-gte], [data-ksf-lte]', d).forEach(function (i) { i.value = ''; });
      apply(0);
      track('ks_filter_clear');
    }

    /* ---------- sizes by foot length (cm / in) ----------
       The same US size is not the same length in every model. A saved foot
       length makes the size bar of Kick Speed: cart & sizes show, on each
       shoe, the size that fits. Under the sizes: one button per saved
       person, or Add your foot length (My sizes on its Add form). */
    function sizesApi() { var k = window.KSFinder; return k && k.sizes && k.sizes.on ? k.sizes : null; }
    function lenTxt(cm) {
      var k = window.KSFinder, l = k && k.recall ? (k.recall() || {}) : {};
      return l.unit === 'in' ? (cm / 2.54).toFixed(2) + ' in' : (Math.round(cm * 10) / 10).toFixed(1).replace(/\.0$/, '') + ' cm';
    }
    function paintFoot() {
      var box = q('[data-ksf-byfoot]');
      if (!box) return;
      var row = q('[data-ksf-byfoot-row]', box);
      var sv = sizesApi(), ms = window.KSMySizes;
      var list = sv ? sv.list() : [];
      var bar = document.querySelector('.kst-mine');
      var canPick = !!(list.length && bar && !bar.hidden);
      var canAdd = !list.length && !!(ms && typeof ms.open === 'function');
      if (!row || (!canPick && !canAdd)) { box.hidden = true; return; }
      var on = bar ? bar.querySelector('.kst-pc.is-on[data-kst-person]') : null;
      var onId = on ? on.getAttribute('data-kst-person') : '';
      var h = '';
      if (canPick) {
        list.forEach(function (p) {
          var sel = p.id === onId;
          h += '<button type="button" class="ks-f__fchip' + (sel ? ' is-on' : '') + '" data-ksf-person="' + String(p.id).replace(/"/g, '&quot;') + '" aria-pressed="' + sel + '">' +
            '<b></b><span>' + lenTxt(p.foot) + '</span></button>';
        });
      } else {
        h = '<button type="button" class="ks-f__fchip ks-f__fchip--add" data-ksf-addsize><span aria-hidden="true">+</span> <b></b></button>';
      }
      row.innerHTML = h;
      /* names and texts as text, never as HTML */
      var names = row.querySelectorAll('b');
      if (canPick) list.forEach(function (p, i) { names[i].textContent = p.name; });
      else names[0].textContent = box.getAttribute('data-add') || 'Add your foot length';
      box.hidden = false;
    }
    function pickPerson(id) {
      var bar = document.querySelector('.kst-mine');
      var cur = bar ? bar.querySelector('.kst-pc.is-on[data-kst-person]') : null;
      /* the same person again: back to Nobody */
      var want = cur && cur.getAttribute('data-kst-person') === id ? '' : id;
      var chip = bar ? bar.querySelector('[data-kst-person="' + esc(want) + '"]') : null;
      if (sheetOpen) closeSheet(false);
      if (popKey) closePop(false);
      if (chip) chip.click();
      else if (window.KSMySizes) window.KSMySizes.open({ view: 'list' });
    }
    function addSize(btn) {
      if (sheetOpen) closeSheet(false);
      if (popKey) closePop(false);
      if (window.KSMySizes) window.KSMySizes.open({ view: 'add', opener: btn });
    }
    document.addEventListener('ks:sizes', function () { if (!gone()) setTimeout(paintFoot, 30); });

    /* ---------- scrolling ---------- */
    /* height of the header that follows the page (the theme's sticky
       header). Its full height, also while it is still sliding in. */
    function headerBottom() {
      var h = document.querySelector('.site-header--stuck') || document.querySelector('.site-header');
      if (!h) return 0;
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return 0;
      return Math.round(h.offsetHeight || 0);
    }
    function setTop() {
      var hb = headerBottom();
      root.style.setProperty('--ksf-top', (hb + 16) + 'px');
      root.style.setProperty('--ksf-hdr', hb + 'px');
    }
    function toResults(force) {
      var r = q('[data-ksf="results"]');
      if (!r) return;
      /* the bar that follows the page sits under the header: keep the first
         products clear of it */
      var fh = floatEl ? floatEl.offsetHeight : 0;
      var top = r.getBoundingClientRect().top - headerBottom() - fh - 12;
      if (force || top < 0) {
        window.scrollTo({ top: Math.max(0, window.pageYOffset + top), behavior: REDUCED ? 'auto' : 'smooth' });
      }
    }

    /* ---------- the panel on phones and tablets ---------- */
    function focusables() {
      return qa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, [tabindex]:not([tabindex="-1"]), summary', panel())
        .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    }
    function openSheet(btn) {
      if (sheetOpen) return;
      var p = panel();
      if (!p) return;
      /* opened from More filters: the panel starts at the first filter
         that did not fit in the row */
      var over = btn && btn.hasAttribute && btn.hasAttribute('data-ksf-more') ? q('.ks-f__group.is-over') : null;
      opener = btn || null;
      popKey = null;
      sheetFrom = lastUrl;
      wantResults = false;
      /* the bar keeps its height while its filters are in the panel, so
         nothing on the page moves */
      if (barEl && root.classList.contains('ks-f--bar') && mqDesk.matches) barEl.style.minHeight = barEl.offsetHeight + 'px';
      sheetOpen = true;
      root.classList.add('is-sheet');
      p.classList.add('is-open');
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      html.classList.add('js-drawer-open', 'ks-f-lock');
      qa('[data-ksf-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      history.pushState({ ksf: 1, sheet: 1 }, '', location.href);
      paintFoot();
      layout();
      floatCheck();
      if (over && over.isConnected) {
        var f = form();
        if (f) f.scrollTop = Math.max(0, over.offsetTop - f.offsetTop - 8);
      }
      setTimeout(function () {
        var x = q('.ks-f__x', p);
        if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
      }, 60);
      track('ks_filter_open');
    }
    function closeSheet(fromPop) {
      if (!sheetOpen) return;
      sheetOpen = false;
      root.classList.remove('is-sheet');
      var p = panel();
      if (p) {
        p.classList.remove('is-open');
        p.removeAttribute('role');
        p.removeAttribute('aria-modal');
      }
      if (barEl) barEl.style.minHeight = '';
      layout();
      floatCheck();
      html.classList.remove('js-drawer-open', 'ks-f-lock');
      qa('[data-ksf-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var changed = lastUrl !== sheetFrom;
      sheetFrom = null;
      if (!fromPop && history.state && history.state.sheet) {
        closing = true;
        history.back();
      }
      if (opener && opener.offsetParent) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
      opener = null;
      /* the filters changed: show the first products. Going Back puts the
         page where it was when the panel opened, so when the panel goes
         Back this waits for that (popstate below). Nothing changed: the
         page stays where it is. */
      if (changed) {
        if (closing) wantResults = true;
        else setTimeout(function () { if (!sheetOpen) toResults(false); }, 0);
      }
    }

    function gone() { return !root.isConnected; } /* the theme editor drew the section again */

    window.addEventListener('popstate', function (e) {
      if (gone()) return;
      if (closing || sheetOpen) {
        /* the panel closed (X, button or Back): keep the filters it set */
        closing = false;
        if (sheetOpen) closeSheet(true);
        history.replaceState({ ksf: 1 }, '', lastUrl);
        if (wantResults) {
          wantResults = false;
          setTimeout(function () { if (!sheetOpen) toResults(false); }, 0);
        }
        return;
      }
      var st = e.state;
      if (st && st.ksf && clean(location.href) !== lastUrl) go(location.href, 'pop');
    });

    document.addEventListener('keydown', function (e) {
      if (gone()) return;
      if (!sheetOpen && popKey && e.key === 'Escape' && barMode()) { e.preventDefault(); closePop(true); return; }
      if (!sheetOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(false); return; }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* turned or resized across the breakpoint: the panel stays as it is,
       the groups follow the layout */
    var onBp = function () {
      if (!sheetOpen && barEl) barEl.style.minHeight = '';
      popKey = null;
      layout();
      floatCheck();
    };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onBp); else if (mqDesk.addListener) mqDesk.addListener(onBp);

    /* ---------- one value on or off (cards and one-tap buttons) ---------- */
    function toggleValue(name, value, btn) {
      var f = form();
      var input = f ? f.querySelector('input[name="' + esc(name) + '"][value="' + esc(value) + '"]') : null;
      var on;
      if (input) {
        input.checked = !input.checked;
        on = input.checked;
        var lab = input.closest('label');
        if (lab) lab.classList.toggle('is-on', on);
        apply(0);
      } else {
        var p = paramsFromForm();
        var vals = p.getAll(name);
        var i = vals.indexOf(value);
        p.delete(name);
        if (i > -1) vals.splice(i, 1); else vals.push(value);
        vals.forEach(function (v) { p.append(name, v); });
        on = i < 0;
        var s = p.toString();
        go(location.pathname + (s ? '?' + s : ''), 'push');
      }
      qa('[data-ksf-toggle]').forEach(function (b) {
        if (b.getAttribute('data-name') === name && b.getAttribute('data-value') === value) {
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
    }

    /* ---------- events (delegated: the parts inside are replaced) ---------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-ksf-sort')) { apply(0); return; }
      if (t.type === 'checkbox' && t.form && t.form.hasAttribute('data-ksf-form')) {
        var lab = t.closest('label');
        if (lab) lab.classList.toggle('is-on', t.checked);
        apply(120);
      }
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      var tg = t.closest('[data-ksf-toggle]');
      if (tg && root.contains(tg)) {
        e.preventDefault();
        if (!tg.disabled) toggleValue(tg.getAttribute('data-name'), tg.getAttribute('data-value'), tg);
        return;
      }
      var a = t.closest('a[data-ksf-link], .pagination a');
      if (a && root.contains(a)) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        e.preventDefault();
        var isPage = !!a.closest('.pagination');
        go(a.getAttribute('href'), 'push').then(function () { if (isPage) toResults(true); });
        if (a.classList.contains('ks-f__clear') || a.classList.contains('ks-f__reset')) track('ks_filter_clear');
        return;
      }
      var op = t.closest('[data-ksf-open]');
      if (op) { openSheet(op); return; }
      if (t.closest('[data-ksf-close]')) { closeSheet(false); return; }
      var fp = t.closest('[data-ksf-person]');
      if (fp && root.contains(fp)) { e.preventDefault(); pickPerson(fp.getAttribute('data-ksf-person')); return; }
      var fa = t.closest('[data-ksf-addsize]');
      if (fa && root.contains(fa)) { e.preventDefault(); addSize(fa); return; }
      var gc = t.closest('[data-ksf-gclear]');
      if (gc && root.contains(gc)) {
        e.preventDefault();
        var gd = gc.closest('[data-ksf-group]');
        if (gd) clearGroup(gd);
        return;
      }
      var sm = t.closest('.ks-f__summary');
      if (sm && root.contains(sm)) {
        var d = sm.parentNode;
        if (!d || !d.hasAttribute('data-ksf-group')) return;
        if (barMode()) {
          /* the bar: the button opens or closes its small window */
          e.preventDefault();
          if (d.hasAttribute('data-ksf-inline')) return;
          if (popKey === keyOfGroup(d)) closePop(false); else openPop(d);
        } else {
          /* the panel: remember what the shopper opened or closed */
          userOpen[keyOfGroup(d)] = !d.open;
        }
      }
    });

    /* the bar: a click anywhere else closes the small window */
    document.addEventListener('click', function (e) {
      if (!popKey || gone() || !barMode()) return;
      var g = popGroup();
      if (!g || !g.isConnected || !g.contains(e.target)) closePop(false);
    });
    /* ... and so does moving on with Tab past it */
    root.addEventListener('focusout', function (e) {
      if (!popKey || !barMode()) return;
      var g = popGroup(), to = e.relatedTarget;
      if (g && to && !g.contains(to)) closePop(false);
    });

    /* ---------- phones: pull the sheet down to close it ----------
       From the top bar of the sheet, or from the list when it is scrolled
       to the top. The sheet follows the finger; far enough or fast enough
       closes it, anything less springs back. The price slider and sideways
       moves are left alone. */
    var mqPhone = window.matchMedia('(max-width: 989px)');
    var pull = null, pullEnd = 0;
    function shade() { return q('.ks-f__shade'); }
    function sheetAt(y, anim) {
      var p = panel(), sh = shade();
      if (!p) return;
      p.style.transition = anim ? 'transform .25s cubic-bezier(.2, .8, .2, 1)' : 'none';
      p.style.transform = y ? 'translateY(' + y + 'px)' : '';
      if (sh) {
        sh.style.transition = anim ? 'opacity .25s' : 'none';
        sh.style.opacity = y ? String(Math.max(0, 1 - y / (p.offsetHeight || 600))) : '';
      }
    }
    function sheetFree() {
      var p = panel(), sh = shade();
      if (p) { p.style.transition = ''; p.style.transform = ''; }
      if (sh) { sh.style.transition = ''; sh.style.opacity = ''; }
    }
    root.addEventListener('touchstart', function (e) {
      pull = null;
      if (!sheetOpen || !mqPhone.matches || !e.touches || e.touches.length !== 1) return;
      var p = panel(), t = e.target;
      if (!p || !t || !t.closest || !p.contains(t)) return;
      if (t.closest('input[type="range"], .ks-f__quick')) return;
      var f = form(), inList = !!(f && f.contains(t));
      var pt = e.touches[0];
      pull = { x: pt.clientX, y: pt.clientY, list: inList, top: !f || f.scrollTop <= 0, on: false, dy: 0, ly: pt.clientY, lt: Date.now(), v: 0 };
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      /* the dimmed page behind the sheet does not scroll */
      if (sheetOpen && e.target === shade()) { if (e.cancelable) e.preventDefault(); return; }
      if (!pull || !e.touches || !e.touches.length) return;
      var pt = e.touches[0], dx = pt.clientX - pull.x, dy = pt.clientY - pull.y;
      if (!pull.on) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        var f = form();
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || (pull.list && (!pull.top || (f && f.scrollTop > 0)))) { pull = null; return; }
        pull.on = true;
      }
      if (e.cancelable) e.preventDefault();
      var now = Date.now();
      pull.v = (pt.clientY - pull.ly) / Math.max(1, now - pull.lt);
      pull.ly = pt.clientY;
      pull.lt = now;
      pull.dy = Math.max(0, dy);
      sheetAt(pull.dy, false);
    }, { passive: false });
    function pullDone() {
      if (!pull) return;
      var d = pull;
      pull = null;
      if (!d.on) return;
      pullEnd = Date.now();
      var p = panel(), h = (p && p.offsetHeight) || 600;
      if (d.dy > Math.min(140, h * 0.25) || (d.v > 0.5 && d.dy > 24)) {
        /* from where the finger left it, the sheet slides the rest of the way */
        sheetFree();
        closeSheet(false);
        track('ks_filter_swipe');
      } else {
        sheetAt(0, true);
        setTimeout(function () { if (!pull) sheetFree(); }, 300);
      }
    }
    root.addEventListener('touchend', pullDone);
    root.addEventListener('touchcancel', pullDone);
    /* a pull is not a tap: nothing in the sheet under the finger is clicked */
    root.addEventListener('click', function (e) {
      var p = panel();
      if (Date.now() - pullEnd < 400 && p && p.contains(e.target)) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* ---------- price slider ---------- */
    function fmt(v) {
      var cents = Math.round(v * 100);
      try {
        if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
          return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
        }
      } catch (e) {}
      return '$' + (cents / 100).toFixed(2);
    }
    /* a fresh element each time: the currency app remembers the amount of an
       element it has already converted */
    function label(old, v) {
      if (!old) return old;
      var nu = document.createElement('span');
      nu.className = 'money';
      if (old.hasAttribute('data-ksf-price-lo')) nu.setAttribute('data-ksf-price-lo', '');
      if (old.hasAttribute('data-ksf-price-hi')) nu.setAttribute('data-ksf-price-hi', '');
      nu.textContent = fmt(v);
      old.parentNode.replaceChild(nu, old);
      return nu;
    }
    function initPrice() {
      qa('[data-ksf-price]').forEach(function (box) {
        if (box.__ksf) return;
        box.__ksf = true;
        var lo = q('[data-ksf-lo]', box), hi = q('[data-ksf-hi]', box);
        var gte = q('[data-ksf-gte]', box), lte = q('[data-ksf-lte]', box);
        if (!lo || !hi) return;
        var min = +box.getAttribute('data-min'), max = +box.getAttribute('data-max');
        var span = Math.max(1, max - min);
        function paint(changeLabels) {
          var a = +lo.value, b = +hi.value;
          box.style.setProperty('--lo', ((a - min) / span * 100) + '%');
          box.style.setProperty('--hi', (100 - (b - min) / span * 100) + '%');
          if (changeLabels) {
            label(q('[data-ksf-price-lo]', box), a);
            label(q('[data-ksf-price-hi]', box), b);
            refreshMoney();
          }
        }
        function commit() {
          gte.value = +lo.value > min ? lo.value : '';
          lte.value = +hi.value < max ? hi.value : '';
          apply(200);
        }
        lo.addEventListener('input', function () { if (+lo.value > +hi.value) lo.value = hi.value; paint(true); });
        hi.addEventListener('input', function () { if (+hi.value < +lo.value) hi.value = lo.value; paint(true); });
        lo.addEventListener('change', commit);
        hi.addEventListener('change', commit);
        paint(false);
      });
    }

    /* ---------- the bar with the Filter button that follows the page ----------
       It slides out from under the header once the filters at the top have
       gone up behind the header, and only while products are on screen. */
    var barVisible = true, resultsVisible = false;
    function floatCheck() {
      if (!floatEl) return;
      var show = !barVisible && resultsVisible && !sheetOpen;
      floatEl.classList.toggle('is-on', show);
    }
    if (floatEl && window.IntersectionObserver && barEl) {
      var res = q('.ks-f__body');
      var hdrEl = document.querySelector('.site-header');
      var hdrH = hdrEl ? Math.round(hdrEl.offsetHeight || 0) : 0;
      new IntersectionObserver(function (list) {
        list.forEach(function (en) { barVisible = en.isIntersecting; });
        /* the bar scrolled away: its small window goes with it */
        if (!barVisible && popKey) closePop(false);
        floatCheck();
      }, { rootMargin: '-' + hdrH + 'px 0px 0px 0px' }).observe(barEl);
      new IntersectionObserver(function (list) {
        list.forEach(function (en) { resultsVisible = en.isIntersecting; });
        floatCheck();
      }).observe(res);
    }

    var raf = 0;
    window.addEventListener('scroll', function () {
      if (raf || gone()) return;
      raf = requestAnimationFrame(function () { raf = 0; setTop(); });
    }, { passive: true });
    window.addEventListener('resize', setTop);
    /* a wider or narrower window or toolbar: the row of filters is fitted again */
    var fitW = window.innerWidth, fitT = 0;
    function refit() {
      clearTimeout(fitT);
      fitT = setTimeout(function () { if (!gone() && barMode()) layout(); }, 120);
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth === fitW) return;
      fitW = window.innerWidth;
      refit();
    });
    if (window.ResizeObserver && barEl) {
      var barW = 0;
      new ResizeObserver(function (list) {
        var w = Math.round(list[0].contentRect.width);
        if (w === barW) return;
        var first = !barW;
        barW = w;
        if (!first) refit();
      }).observe(barEl);
    }
    /* the shop's font arrives after the first fit and changes the widths */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!gone() && barMode()) layout(); });
    }

    /* start */
    if (!history.state || !history.state.ksf) {
      try { history.replaceState({ ksf: 1 }, '', location.href); } catch (e) {}
    }
    setTop();
    initPrice();
    layout();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ks-f]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* theme editor: the section is drawn again after every change */
  document.addEventListener('shopify:section:load', boot);
})();